import { Injectable } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  constructor() {}

  loadImage(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = () => resolve(img);

      img.onerror = reject;

      img.src = src;
    });
  }

  getChartImage(chart) {
    return this.loadImage(chart?.getDataURL());
  }

  async exportAsPDF(divId) {
    try {
      if (divId === 'full') {
        divId = 'fullpagecharts';
      }
      let element;
      if (divId) {
        element = document.getElementById(divId);
      }
      if (element) {
        html2canvas(element).then((canvas) => {
          const contentDataURL = canvas.toDataURL('image/png');
          // eslint-disable-next-line prefer-const
          let pdf = new jspdf.jsPDF('p', 'mm', 'a4', true); // A4 size page of PDF
          // eslint-disable-next-line prefer-const
          let width = pdf.internal.pageSize.getWidth() - 20;
          // eslint-disable-next-line prefer-const
          let height = (canvas.height * width) / canvas.width;

          pdf.addImage(
            contentDataURL,
            'PNG',
            10,
            30,
            width,
            height,
            undefined,
            'FAST'
          );
          pdf.save('output.pdf'); // Generated PDF
        });
      }
    } catch (e) {
      console.error('failed to export', e);
    }
  }
}
